import classes from "./SeedLister.module.css"
import Control from "./Shop/Control"
import ResultSet from "./Shop/ResultSet"
import { useState } from "react"
import {
    useLocalStorage,
    decrypted_key,
    get_eligible_headgear,
    get_eligible_clothes,
    get_eligible_shoes,
    stickerShop,
    figureShop,
    doorShop,
} from "../../Utils"
import XORSHIFT128 from "./RNGLib"
import MurmurHash3 from "murmurhash3js"
import { useTranslation } from "react-i18next"
import { defaultProfile } from "../../DefaultEntries"

const gear_shop_rarity = [
    6, 0, 0, 3, 0, 0, 6, 0, 0, 3, 0, 0, 6, 0, 0, 2, 1, 0, 4, 2, 0, 2, 1, 0, 3, 2, 0, 2, 1, 1, 2, 2, 1, 1, 2, 1, 2, 2, 2, 1, 1, 1,
]
const decoration_shop_rarity = [0, 4, 0, 0, 4, 0, 0, 1, 0, 0, 4, 0, 0, 4, 0, 0, 1, 0, 0, 3, 1, 0, 3, 1, 0, 1, 0, 0, 2, 2, 0, 2, 2, 0, 1, 0]

const blitzgambit = [
    [
        "Hed_ACC001",
        "Hed_AMB000",
        "Hed_AMB001",
        "Hed_AMB002",
        "Hed_AMB003",
        "Hed_AMB004",
        "Hed_AMB005",
        "Hed_AMB006",
        "Hed_AMB007",
        "Hed_AMB008",
        "Hed_AMB009",
        "Hed_AMB010",
        "Hed_CAP000",
        "Hed_CAP001",
        "Hed_CAP002",
        "Hed_CAP003",
        "Hed_CAP004",
        "Hed_CAP005",
        "Hed_CAP006",
        "Hed_CAP007",
        "Hed_CAP008",
        "Hed_CAP009",
        "Hed_CAP010",
        "Hed_CAP011",
        "Hed_CAP012",
        "Hed_CAP013",
        "Hed_CAP014",
        "Hed_CAP015",
        "Hed_CAP016",
        "Hed_CAP018",
        "Hed_CAP019",
        "Hed_CAP020",
        "Hed_CAP021",
        "Hed_CAP023",
        "Hed_CAP024",
        "Hed_CAP025",
        "Hed_CAP026",
        "Hed_CAP027",
        "Hed_COP100",
        "Hed_COP101",
        "Hed_COP102",
        "Hed_COP103",
        "Hed_COP104",
        "Hed_COP105",
        "Hed_COP106",
        "Hed_COP107",
        "Hed_COP108",
        "Hed_COP109",
        "Hed_CRC000",
        "Hed_EYE000",
        "Hed_EYE001",
        "Hed_EYE002",
        "Hed_EYE003",
        "Hed_EYE004",
        "Hed_EYE005",
        "Hed_EYE006",
        "Hed_EYE007",
        "Hed_EYE008",
        "Hed_EYE009",
        "Hed_EYE010",
        "Hed_EYE011",
        "Hed_EYE012",
        "Hed_EYE013",
        "Hed_EYE014",
        "Hed_EYE015",
        "Hed_EYE016",
        "Hed_EYE017",
        "Hed_EYE018",
        "Hed_EYE019",
        "Hed_EYE020",
        "Hed_FST000",
        "Hed_First",
        "Hed_HAP000",
        "Hed_HAP001",
        "Hed_HAP002",
        "Hed_HAP003",
        "Hed_HAP004",
        "Hed_HAP005",
        "Hed_HAP006",
        "Hed_HAP007",
        "Hed_HAP008",
        "Hed_HAP009",
        "Hed_HAP010",
        "Hed_HAP011",
        "Hed_HAP012",
        "Hed_HAP013",
        "Hed_HAP014",
        "Hed_HAP015",
        "Hed_HAT000",
        "Hed_HAT001",
        "Hed_HAT002",
        "Hed_HAT003",
        "Hed_HAT004",
        "Hed_HAT005",
        "Hed_HAT006",
        "Hed_HAT007",
        "Hed_HAT008",
        "Hed_HAT009",
        "Hed_HAT010",
        "Hed_HAT011",
        "Hed_HAT012",
        "Hed_HAT013",
        "Hed_HAT014",
        "Hed_HBD001",
        "Hed_HBD002",
        "Hed_HBD003",
        "Hed_HBD004",
        "Hed_HBD005",
        "Hed_HBD006",
        "Hed_HBD007",
        "Hed_HBD008",
        "Hed_HDP000",
        "Hed_HDP001",
        "Hed_HDP002",
        "Hed_HDP003",
        "Hed_HDP004",
        "Hed_HDP005",
        "Hed_HDP006",
        "Hed_Invisible",
        "Hed_MET000",
        "Hed_MET002",
        "Hed_MET003",
        "Hed_MET004",
        "Hed_MET005",
        "Hed_MET006",
        "Hed_MET007",
        "Hed_MET008",
        "Hed_MET009",
        "Hed_MET010",
        "Hed_MET011",
        "Hed_MSK000",
        "Hed_MSK001",
        "Hed_MSK002",
        "Hed_MSK003",
        "Hed_MSK004",
        "Hed_MSK005",
        "Hed_MSK006",
        "Hed_MSK007",
        "Hed_MSK008",
        "Hed_MSK009",
        "Hed_MSK010",
        "Hed_MSK011",
        "Hed_MSK012",
        "Hed_MSK013",
        "Hed_MSN000",
        "Hed_MSN001",
        "Hed_MSN002",
        "Hed_MSN003",
        "Hed_MSN004",
        "Hed_MSN101",
        "Hed_MSN104",
        "Hed_MSN105",
        "Hed_MSN106",
        "Hed_MSN107",
        "Hed_MSN108",
        "Hed_NCP000",
        "Hed_NCP001",
        "Hed_NCP002",
        "Hed_NCP003",
        "Hed_NCP004",
        "Hed_NCP005",
        "Hed_NCP006",
        "Hed_NCP008",
        "Hed_NCP009",
        "Hed_NCP010",
        "Hed_NCP011",
        "Hed_RVL000",
        "Hed_RVL001",
        "Hed_SUP000",
        "Hed_SUP001",
        "Hed_VIS000",
        "Hed_VIS001",
        "Hed_VIS002",
        "Hed_VIS003",
        "Hed_VIS004",
    ],

    [
        "Clt_AMB000",
        "Clt_AMB001",
        "Clt_AMB002",
        "Clt_AMB003",
        "Clt_AMB004",
        "Clt_AMB005",
        "Clt_AMB006",
        "Clt_AMB007",
        "Clt_AMB008",
        "Clt_AMB009",
        "Clt_AMB010",
        "Clt_COP100",
        "Clt_COP101",
        "Clt_COP102",
        "Clt_COP103",
        "Clt_COP104",
        "Clt_COP105",
        "Clt_COP106",
        "Clt_COP107",
        "Clt_COP108",
        "Clt_COP109",
        "Clt_COP110",
        "Clt_CRC000",
        "Clt_FST001",
        "Clt_FST002",
        "Clt_First",
        "Clt_HAP000",
        "Clt_HAP001",
        "Clt_HAP002",
        "Clt_Invisible",
        "Clt_JKT000",
        "Clt_JKT001",
        "Clt_JKT002",
        "Clt_JKT003",
        "Clt_JKT004",
        "Clt_JKT005",
        "Clt_JKT006",
        "Clt_JKT007",
        "Clt_JKT008",
        "Clt_JKT009",
        "Clt_JKT010",
        "Clt_JKT011",
        "Clt_JKT012",
        "Clt_JKT013",
        "Clt_JKT014",
        "Clt_JKT015",
        "Clt_JKT016",
        "Clt_JKT017",
        "Clt_JKT018",
        "Clt_JKT019",
        "Clt_JKT020",
        "Clt_JKT021",
        "Clt_JKT022",
        "Clt_JKT023",
        "Clt_JKT024",
        "Clt_JKT025",
        "Clt_JKT026",
        "Clt_JKT027",
        "Clt_JKT028",
        "Clt_JKT029",
        "Clt_JKT030",
        "Clt_JKT031",
        "Clt_JKT032",
        "Clt_JKT033",
        "Clt_JKT034",
        "Clt_JKT035",
        "Clt_JKT036",
        "Clt_JKT037",
        "Clt_JKT038",
        "Clt_JKT039",
        "Clt_JKT040",
        "Clt_JKT041",
        "Clt_JKT042",
        "Clt_JKT043",
        "Clt_JKT044",
        "Clt_MSN000",
        "Clt_MSN001",
        "Clt_MSN002",
        "Clt_MSN003",
        "Clt_MSN004",
        "Clt_MSN101",
        "Clt_MSN104",
        "Clt_MSN105",
        "Clt_MSN106",
        "Clt_PLO000",
        "Clt_PLO001",
        "Clt_PLO002",
        "Clt_PLO003",
        "Clt_PLO004",
        "Clt_PLO005",
        "Clt_PLO006",
        "Clt_PLO007",
        "Clt_PLO008",
        "Clt_PRK000",
        "Clt_PRK001",
        "Clt_PRK002",
        "Clt_PRK003",
        "Clt_PRK004",
        "Clt_PRK005",
        "Clt_PRK006",
        "Clt_PRK007",
        "Clt_PRK008",
        "Clt_PRK009",
        "Clt_PRK010",
        "Clt_PRK011",
        "Clt_RVL000",
        "Clt_SHT000",
        "Clt_SHT001",
        "Clt_SHT002",
        "Clt_SHT003",
        "Clt_SHT004",
        "Clt_SHT005",
        "Clt_SHT006",
        "Clt_SHT007",
        "Clt_SHT008",
        "Clt_SHT009",
        "Clt_SHT010",
        "Clt_SHT011",
        "Clt_SHT012",
        "Clt_SHT013",
        "Clt_SHT014",
        "Clt_SHT015",
        "Clt_SHT016",
        "Clt_SHT017",
        "Clt_SHT018",
        "Clt_SHT019",
        "Clt_SHT020",
        "Clt_SHT021",
        "Clt_SHT022",
        "Clt_SHT023",
        "Clt_SHT024",
        "Clt_SHT025",
        "Clt_SHT026",
        "Clt_SHT027",
        "Clt_SHT028",
        "Clt_SHT029",
        "Clt_SUP000",
        "Clt_SUP001",
        "Clt_SWT000",
        "Clt_SWT001",
        "Clt_SWT002",
        "Clt_SWT003",
        "Clt_SWT004",
        "Clt_SWT005",
        "Clt_SWT006",
        "Clt_SWT007",
        "Clt_SWT008",
        "Clt_SWT009",
        "Clt_SWT010",
        "Clt_SWT011",
        "Clt_SWT012",
        "Clt_SWT013",
        "Clt_SWT014",
        "Clt_SWT015",
        "Clt_TEL000",
        "Clt_TEL001",
        "Clt_TEL002",
        "Clt_TEL003",
        "Clt_TEL004",
        "Clt_TEL005",
        "Clt_TEL006",
        "Clt_TEL007",
        "Clt_TEL008",
        "Clt_TEL009",
        "Clt_TEL010",
        "Clt_TEL011",
        "Clt_TEL012",
        "Clt_TEL013",
        "Clt_TEL014",
        "Clt_TEL015",
        "Clt_TEL016",
        "Clt_TEL017",
        "Clt_TEL018",
        "Clt_TEL019",
        "Clt_TEL020",
        "Clt_TEL021",
        "Clt_TEL022",
        "Clt_TEL023",
        "Clt_TEL024",
        "Clt_TES000",
        "Clt_TES001",
        "Clt_TES003",
        "Clt_TES004",
        "Clt_TES005",
        "Clt_TES006",
        "Clt_TES007",
        "Clt_TES008",
        "Clt_TES009",
        "Clt_TES010",
        "Clt_TES011",
        "Clt_TES012",
        "Clt_TES013",
        "Clt_TES014",
        "Clt_TES015",
        "Clt_TES016",
        "Clt_TES017",
        "Clt_TES018",
        "Clt_TES019",
        "Clt_TES020",
        "Clt_TES021",
        "Clt_TES022",
        "Clt_TES023",
        "Clt_TES024",
        "Clt_TES025",
        "Clt_TES026",
        "Clt_TES027",
        "Clt_TES028",
        "Clt_TES029",
        "Clt_TES030",
        "Clt_TES031",
        "Clt_TES032",
        "Clt_TES033",
        "Clt_TES034",
        "Clt_TES035",
        "Clt_TES036",
        "Clt_TES037",
        "Clt_TES038",
        "Clt_TES039",
        "Clt_TES040",
        "Clt_TES041",
        "Clt_TES042",
        "Clt_TES043",
        "Clt_TES044",
        "Clt_TES045",
        "Clt_TES046",
        "Clt_TES047",
        "Clt_TES048",
        "Clt_TES049",
        "Clt_TES050",
        "Clt_TES051",
        "Clt_TES052",
        "Clt_TES053",
        "Clt_TES054",
        "Clt_TES055",
        "Clt_TES056",
        "Clt_TES057",
        "Clt_TES058",
        "Clt_TES059",
        "Clt_TES060",
        "Clt_TES061",
        "Clt_TLY000",
        "Clt_TLY001",
        "Clt_TLY002",
        "Clt_TLY003",
        "Clt_TLY004",
        "Clt_TLY005",
        "Clt_TLY006",
        "Clt_TLY007",
        "Clt_TLY008",
        "Clt_TLY009",
        "Clt_TLY010",
        "Clt_TLY011",
        "Clt_TLY012",
        "Clt_TLY013",
        "Clt_TNK000",
        "Clt_TNK001",
        "Clt_TNK002",
        "Clt_TNK003",
        "Clt_TNK004",
        "Clt_TNK005",
        "Clt_TNK006",
        "Clt_VST000",
        "Clt_VST001",
        "Clt_VST002",
        "Clt_VST003",
        "Clt_VST004",
        "Clt_VST005",
        "Clt_VST007",
        "Clt_VST008",
        "Clt_VST009",
    ],

    [
        "Shs_AMB000",
        "Shs_AMB001",
        "Shs_AMB002",
        "Shs_AMB003",
        "Shs_AMB004",
        "Shs_AMB005",
        "Shs_AMB006",
        "Shs_AMB007",
        "Shs_AMB008",
        "Shs_AMB009",
        "Shs_AMB010",
        "Shs_BOT000",
        "Shs_BOT001",
        "Shs_BOT002",
        "Shs_BOT003",
        "Shs_BOT004",
        "Shs_BOT005",
        "Shs_BOT006",
        "Shs_BOT007",
        "Shs_BOT008",
        "Shs_BOT009",
        "Shs_BOT010",
        "Shs_BOT011",
        "Shs_BOT012",
        "Shs_BOT013",
        "Shs_BOT014",
        "Shs_BOT015",
        "Shs_BOT016",
        "Shs_BOT017",
        "Shs_BOT018",
        "Shs_CFS000",
        "Shs_CFS001",
        "Shs_COP101",
        "Shs_COP102",
        "Shs_COP103",
        "Shs_COP104",
        "Shs_COP105",
        "Shs_COP106",
        "Shs_CRC000",
        "Shs_FST000",
        "Shs_First",
        "Shs_HAP000",
        "Shs_HAP001",
        "Shs_HAP002",
        "Shs_HAP003",
        "Shs_HAP004",
        "Shs_HAP005",
        "Shs_HAP006",
        "Shs_HAP007",
        "Shs_Invisible",
        "Shs_LTS000",
        "Shs_LTS001",
        "Shs_LTS002",
        "Shs_LTS003",
        "Shs_LTS004",
        "Shs_LTS005",
        "Shs_LTS006",
        "Shs_LTS007",
        "Shs_LTS008",
        "Shs_LTS009",
        "Shs_LTS010",
        "Shs_LTS011",
        "Shs_LTS012",
        "Shs_MSN000",
        "Shs_MSN001",
        "Shs_MSN002",
        "Shs_MSN003",
        "Shs_MSN004",
        "Shs_MSN101",
        "Shs_MSN104",
        "Shs_MSN105",
        "Shs_MSN106",
        "Shs_RVL000",
        "Shs_SDL000",
        "Shs_SDL001",
        "Shs_SDL002",
        "Shs_SDL003",
        "Shs_SDL004",
        "Shs_SDL005",
        "Shs_SDL006",
        "Shs_SDL007",
        "Shs_SDL008",
        "Shs_SDL009",
        "Shs_SHI000",
        "Shs_SHI001",
        "Shs_SHI002",
        "Shs_SHI003",
        "Shs_SHI004",
        "Shs_SHI005",
        "Shs_SHI006",
        "Shs_SHI007",
        "Shs_SHI008",
        "Shs_SHI009",
        "Shs_SHI010",
        "Shs_SHI011",
        "Shs_SHI012",
        "Shs_SHI013",
        "Shs_SHI014",
        "Shs_SHI015",
        "Shs_SHI016",
        "Shs_SHI017",
        "Shs_SHI018",
        "Shs_SHI019",
        "Shs_SHI020",
        "Shs_SHI021",
        "Shs_SHI022",
        "Shs_SHI023",
        "Shs_SHI024",
        "Shs_SHI025",
        "Shs_SHI026",
        "Shs_SHI027",
        "Shs_SHI028",
        "Shs_SHI029",
        "Shs_SHI030",
        "Shs_SHI031",
        "Shs_SHI032",
        "Shs_SHI033",
        "Shs_SHI034",
        "Shs_SHI035",
        "Shs_SHI036",
        "Shs_SHI037",
        "Shs_SHI038",
        "Shs_SHI039",
        "Shs_SHI040",
        "Shs_SHI041",
        "Shs_SHT000",
        "Shs_SHT001",
        "Shs_SHT002",
        "Shs_SHT003",
        "Shs_SHT004",
        "Shs_SHT005",
        "Shs_SHT006",
        "Shs_SHT007",
        "Shs_SHT008",
        "Shs_SHT009",
        "Shs_SHT010",
        "Shs_SHT011",
        "Shs_SHT012",
        "Shs_SHT013",
        "Shs_SHT014",
        "Shs_SHT015",
        "Shs_SHT016",
        "Shs_SHT017",
        "Shs_SHT018",
        "Shs_SHT019",
        "Shs_SLO000",
        "Shs_SLO001",
        "Shs_SLO002",
        "Shs_SLO003",
        "Shs_SLO004",
        "Shs_SLO005",
        "Shs_SLO006",
        "Shs_SLO007",
        "Shs_SLO008",
        "Shs_SLO009",
        "Shs_SLO010",
        "Shs_SLO011",
        "Shs_SLO012",
        "Shs_SLO013",
        "Shs_SLO014",
        "Shs_SLO015",
        "Shs_SLO016",
        "Shs_SLO017",
        "Shs_SLO018",
        "Shs_SLO019",
        "Shs_SLO020",
        "Shs_SLP000",
        "Shs_SLP001",
        "Shs_SLP002",
        "Shs_SLP003",
        "Shs_SUP000",
        "Shs_SUP001",
        "Shs_TRS000",
        "Shs_TRS001",
        "Shs_TRS002",
    ],
]

const Shop = props => {
    const { t } = useTranslation()

    const [currentStartTime, setCurrentStartTime] = useState(new Date())
    const [results, setResults] = useState([])
    const [profile] = useLocalStorage("profile", defaultProfile)

    const get_xorshift = () => {
        return new XORSHIFT128(
            (((MurmurHash3.x86.hash32(decrypted_key()) >>> 0) +
                (parseInt((currentStartTime.getTime() - currentStartTime.getTimezoneOffset() * 60 * 1000) / 86400000) << 11)) &
                0xffffffff) >>>
                0,
            1
        )
    }

    const format_date_string = val => {
        return val.split(":")[0].replace("T", "").replaceAll("-", "")
    }

    const calculateResults = () => {
        const shop = [[], [], [], []]
        let res = 0
        if (profile.Level > 20) {
            res = 6
        } else if (profile.Level > 15) {
            res = 5
        } else if (profile.Level > 12) {
            res = 4
        } else if (profile.Level > 9) {
            res = 3
        } else if (profile.Level > 6) {
            res = 2
        } else {
            res = 1
        }

        const gears = [get_eligible_headgear(), get_eligible_clothes(), get_eligible_shoes()]
        let rng = get_xorshift()
        for (let gear_type = 0; gear_type < 3; gear_type++) {
            const picked_gear = []
            for (let slot = 0; slot < 2; slot++) {
                for (let starcount = 0; starcount < 3; starcount++) {
                    for (let i = 0; i < gear_shop_rarity[6 * res + 3 * slot + starcount]; i++) {
                        const work_gear = gears[gear_type].filter(
                            e =>
                                e.Rarity === starcount &&
                                !picked_gear.includes(e.__RowId) &&
                                ((slot === 0 && blitzgambit[gear_type].includes(e.__RowId)) ||
                                    (slot === 1 && !blitzgambit[gear_type].includes(e.__RowId)))
                        )
                        const gear_id = rng.get_rand_int(0, work_gear.length)
                        picked_gear.push(work_gear[gear_id].__RowId)
                        shop[gear_type].push(<Gear key={work_gear[gear_id].__RowId} elem={work_gear[gear_id]} />)
                    }
                }
            }
        }

        rng = get_xorshift()
        const goods = [figureShop(), stickerShop(), doorShop()]
        setResults(shop)
        if (profile.Level >= 30) {
            res = 3
        } else if (profile.Level >= 15) {
            res = 2
        } else {
            res = 1
        }
        const picked_goods = []
        for (let goods_type = 0; goods_type < 3; goods_type++) {
            for (let starcount = 0; starcount < 3; starcount++) {
                for (let i = 0; i < decoration_shop_rarity[9 * res + 3 * goods_type + starcount]; i++) {
                    let work_good
                    if (goods_type === 2) {
                        const t = rng.get_u32()
                        const goods_type_id = parseInt((t * (res >= 2 ? 3 : 2)) / 0x100000000)
                        const r = rng.get_u32()
                        let tmp_rarity = (r >>> 31) + 1
                        let new_rarity

                        if (goods_type_id !== 2) {
                            tmp_rarity = 1
                        }
                        if (res !== 3) {
                            tmp_rarity = 1
                        }
                        if (goods_type_id >= 2) {
                            new_rarity = tmp_rarity
                        } else {
                            new_rarity = 2
                        }

                        work_good = goods[goods_type_id].filter(e => e.Rarity === new_rarity && !picked_goods.includes(e.__RowId))
                        let elem_index
                        if (goods_type_id < 2) {
                            elem_index = parseInt((r * work_good.length) / 0x100000000 + 0) % work_good.length
                        } else {
                            elem_index = rng.get_rand_int(0, work_good.length)
                        }
                        picked_goods.push(work_good[elem_index].__RowId)
                        if (goods_type_id === 0) {
                            shop[3].push(<GoodFigure key={work_good[elem_index].__RowId} elem={work_good[elem_index]} />)
                        } else if (goods_type_id === 1) {
                            shop[3].push(<GoodSticker key={work_good[elem_index].__RowId} elem={work_good[elem_index]} />)
                        } else if (goods_type_id === 2) {
                            shop[3].push(<GoodDoor key={work_good[elem_index].__RowId} elem={work_good[elem_index]} />)
                        }
                    } else {
                        work_good = goods[goods_type].filter(e => e.Rarity === starcount && !picked_goods.includes(e.__RowId))
                        const goods_id = rng.get_rand_int(0, work_good.length)
                        picked_goods.push(work_good[goods_id].__RowId)
                        if (goods_type === 0) {
                            shop[3].push(<GoodFigure key={work_good[goods_id].__RowId} elem={work_good[goods_id]} />)
                        } else {
                            shop[3].push(<GoodSticker key={work_good[goods_id].__RowId} elem={work_good[goods_id]} />)
                        }
                    }
                }
            }
        }
    }
    return (
        <>
            <Control
                selectValue={currentStartTime}
                selectChange={setCurrentStartTime}
                calculateResults={calculateResults}
                format_date_string={format_date_string}
            />
            <div className={classes.WrapperRound}>{t("misc:SeedListing.ShopInfo")}</div>
            {<ResultSet results={results} />}
        </>
    )
}

const Gear = props => {
    const { t } = useTranslation()

    const gear_type = props.elem.__RowId.includes("Hed_")
        ? "GearName_Head"
        : props.elem.__RowId.includes("Clt_")
        ? "GearName_Clothes"
        : "GearName_Shoes"
    const gear_name = props.elem.__RowId.replace("Hed_", "").replace("Clt_", "").replace("Shs_", "")
    return (
        <div className={classes.GearSlot}>
            <div className={classes.GearImage}>
                <center>
                    <img src={`https://leanny.github.io/splat3/images/gear/${props.elem.__RowId}.png`} alt={props.elem.__RowId} />
                </center>
            </div>
            <div className={classes.GearBrand}>
                <center>
                    <img
                        src={`https://leanny.github.io/splat3/images/brand/${props.elem.Brand}.png`}
                        alt={props.elem.__RowId}
                        width={48}
                        className={classes.Brand}
                    />
                    <img
                        src={`https://leanny.github.io/splat3/images/skill//${props.elem.Skill}.png`}
                        alt={props.elem.__RowId}
                        width={48}
                        className={classes.Ability}
                    />
                </center>
            </div>
            <div className={classes.GearName}>
                <center>{t(`translation:CommonMsg.Gear.${gear_type}.${gear_name}`)}</center>
            </div>
            <div className={classes.GearPrice}>
                <center>{props.elem.Price}</center>
            </div>
            <div className={classes.GearRarity}>
                <center>{props.elem.Rarity}⭐</center>
            </div>
        </div>
    )
}

const GoodFigure = props => {
    const { t } = useTranslation()
    return (
        <div className={classes.GearSlot}>
            <div className={classes.GearImage}>
                <center>
                    <img
                        src={`https://leanny.github.io/splat3/images/zakka/${props.elem.__RowId}.png`}
                        alt={props.elem.__RowId}
                        width={128}
                    />
                </center>
            </div>
            <div className={classes.GearName}>
                <center>{t(`translation:CommonMsg.Goods.GoodsName.${props.elem.__RowId}`)}</center>
            </div>
            <div className={classes.GearPrice}>
                <center>{props.elem.Price}</center>
            </div>
        </div>
    )
}

const GoodSticker = props => {
    const { t } = useTranslation()
    return (
        <div className={classes.GearSlot}>
            <div className={classes.GearImage}>
                <center>
                    <img
                        src={`https://leanny.github.io/splat3/images/zakka/${props.elem.__RowId}.png`}
                        alt={props.elem.__RowId}
                        width={128}
                    />
                </center>
            </div>
            <div className={classes.GearName}>
                <center>{t(`translation:CommonMsg.Goods.GoodsName.${props.elem.__RowId}`)}</center>
            </div>
            <div className={classes.GearPrice}>
                <center>{props.elem.Price}</center>
            </div>
        </div>
    )
}

const GoodDoor = props => {
    const { t } = useTranslation()
    return (
        <div className={classes.GearSlot}>
            <div className={classes.GearImage}>
                <center>
                    <img
                        src={`https://leanny.github.io/splat3/images/zakka/${props.elem.__RowId}.png`}
                        alt={props.elem.__RowId}
                        width={128}
                    />
                </center>
            </div>
            <div className={classes.GearName}>
                <center>{t(`translation:CommonMsg.Goods.GoodsName.${props.elem.__RowId}`)}</center>
            </div>
            <div className={classes.GearPrice}>
                <center>{props.elem.Price}</center>
            </div>
        </div>
    )
}

export default Shop
